export default class BlogPage {
	init() {
		const article = document.querySelectorAll('.blog-page article');

		article.forEach(function (post, index) {
			setTimeout(function () {
				post.classList.add('animate__animated', 'animate__fadeIn', 'animate__slow');
			}, index * 200);
		});
	}
}